import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import TableLoader from "../../../../utils/TableLoader";
import PaginationComponent from "../../../../utils/PaginationComponent";
import OrderFormFields from "../Components/OrderFormFields";
import OrderWineFilter from "../Components/OrderWineFilter";
import defaultImage from "../../../../utils/DefaultImage";
import OrderSearchBar from "../Components/OrderSearchBar";
import { IoClose } from "react-icons/io5";
import { TiTick } from "react-icons/ti";
import OrderCart from "../Components/OrderCart";

const OrderAdd = (props) => {
    const { rest_slug2 } = useParams();
    const navigate = useNavigate();
    const { setIsAddOrder, getOrdersData } = props;
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const token = localStorage.getItem("token");

    const [isLoading, setIsLoading] = useState({ main: false, edit: false, save: false });

    const [orderData, setOrderData] = useState(
        {
            customer_code: "12345",
            customer_name: "",
            type_of_operation: "",
            product_quantity: "",
            id_address_delivery: "",
            company_name_recipient: "",
            calculated_field4: "",
            postal_code: "",
            city: "",
            delivery_state_code: "",
            country: "",
            phone: "",
            email: "",
            customer_message: "",
            mobile: "",
            carrier_name: "",
            gift_wrapping: true,
            calculated_field5: "",
            note: "",
            invoice_required: false,
            vat_number: "",
            tax_code: "",
            address: "",
            province: "",
            fax: "",
            sdi_code: "",
            certified_email: "",
            iban: "",
            payment_condition_code: "",
            contact_person: "",
            cl_delivery_notes: "",
            send_date: "",
            delivery_date: "",
            document_type: "",
            reference: "",
            notes: "",
            shipping_code: "",
            delivery_code: "",
            agent_code: "",
            product_code: "",
            product_description: "",
            product_price: "",
            product_discount1: "",
            product_discount2: "",
            product_discount3: "",
            product_unit: "",
            product_notes: "",
            product_discount: "",
            product_gift: "",
            closing_discount: "",
            delivery_notes: "",
            destination_delivery_notes: "",
            product_vat: "",
            special_delivery_notes: "",
        }
    );

    const [allwinesData, setAllwinesData] = useState([]);
    const [allProvinceData, setAllProvinceData] = useState([]);
    const [selectedAllwines, setSelectedAllwines] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState(null);

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [showOptionProvince, setShowOptionProvince] = useState({ destination_province: false });

    const [showOptionAddress, setShowOptionAddress] = useState({ destination_address: false });

    const [searchQueryProvince, setSearchQueryProvince] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    const [showOption, setShowOption] = useState({
        nation: false,
        region: false,
        wine: false,
        product_type: false,
        // category_type: false,
    });

    const [filteredNation, setFilteredNation] = useState("");
    const [filteredRegion, setFilteredRegion] = useState("");
    const [filteredWine, setFilteredWine] = useState("");
    const [filteredProductType, setFilteredProductType] = useState("");
    // const [filteredCategoryType, setFilteredCategoryType] = useState("");

    const [filteredNationArray, setFilteredNationArary] = useState([]);
    const [filteredRegionArray, setFilteredRegionArary] = useState([]);
    const [filteredWineArray, setFilteredWineArary] = useState([]);
    const [filteredProductTypeArray, setFilteredProductTypeArary] = useState([]);

    // const [filteredCategoryTypeArary, setFilteredCategoryTypeArary] = useState([]);


    const [searchCodice, setSearchCodice] = useState("");
    const [searchNome, setSearchNome] = useState("");

    const [addresses, setAddresses] = useState([]);

    const [selectedAddressId, setSelectedAddressId] = useState(null);

    const getWineDataOld = async (atr, searchData) => {
        setIsLoading((prev) => ({ ...prev, main: true }));
        setShowOption({
            nation: false,
            region: false,
            wine: false,
            product_type: false,
        });

        try {
            let params = {
                pageNumber: page,
                size: rowsPerPage,
            };

            if (atr === "name") {
                setPage(1);
                params.pageNumber = 1;
                params.search = searchData?.target?.value;
                params.key = atr;

            } else if (atr === "code") {
                setPage(1);
                params.pageNumber = 1;
                params.search = searchData?.target?.value;
                params.key = atr;
            }

            if (atr !== "clear") {
                if (filteredNation.length > 0) {
                    params.nation = filteredNation.join(",");
                }
                if (filteredRegion.length > 0) {
                    params.region = filteredRegion.join(",");
                }
                if (filteredWine.length > 0) {
                    params.wine = filteredWine.join(",");
                }
                if (filteredProductType.length > 0) {
                    params.product_type = filteredProductType.join(",");
                }
            } else {
                // Reset filters when "clear" is triggered
                setFilteredNation([]);
                setFilteredRegion([]);
                setFilteredWine([]);
                setFilteredProductType([]);
                // setFilteredCategoryType([]);
            }

            const response = await axios.get(`${apiUrl}/api/v1/wines`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setAllwinesData(response?.data?.data || []);
            setTotalPages(response?.data?.total);
        } catch (error) {
            console.error("Error fetching wine data:", error);
        } finally {
            setIsLoading((prev) => ({ ...prev, main: false }));
        }
    };


    const getWineData = async (key, searchValue = "") => {
        searchValue = searchValue.trim();

        setIsLoading((prev) => ({ ...prev, main: true }));

        const isEmptySearch = searchValue === "";
        const isEmptyFilters =
            filteredNation.length === 0 &&
            filteredRegion.length === 0 &&
            filteredWine.length === 0 &&
            filteredProductType.length === 0 ;
            // &&
            // filteredCategoryType.length === 0;


        if (key === "clear" || (isEmptySearch && isEmptyFilters)) {
            setFilteredNation([]);
            setFilteredRegion([]);
            setFilteredWine([]);
            setFilteredProductType([]);
            // setFilteredCategoryType([]);
            setAllwinesData([]);
            setSearchCodice("");
            setSearchNome("");
            setIsLoading((prev) => ({ ...prev, main: false }));
            return;
        }

        try {
            let params = {
                pageNumber: page,
                size: rowsPerPage,
                key,
                search: searchValue,
                status: 'active',
            };


            if (filteredNation.length > 0) params.nation = filteredNation.join(",");
            if (filteredRegion.length > 0) params.region = filteredRegion.join(",");
            if (filteredWine.length > 0) params.wine = filteredWine.join(",");
            if (filteredProductType.length > 0) params.product_type = filteredProductType.join(",");
            // if (filteredCategoryType.length > 0) params.category = filteredCategoryType.join(",");


            const response = await axios.get(`${apiUrl}/api/v1/wines`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setAllwinesData(response?.data?.data || []);
            setTotalPages(response?.data?.total);
        } catch (error) {
            console.error("Error fetching wine data:", error);
        } finally {
            setIsLoading((prev) => ({ ...prev, main: false }));
        }
    };

    const getFilterOptions = async () => {
        try {
            const response = await axios.get(`${apiUrl}/api/v1/wineFilterOptions`, {
                params: {
                    IsWine: 'Active'
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = response.data;
            setFilteredNationArary(data?.nations || []);
            setFilteredRegionArary(data?.regions || []);
            setFilteredWineArary(data?.grape_varieties || []);
            setFilteredProductTypeArary(data?.product_types || []);

            // setFilteredCategoryTypeArary(data?.categories || []);
        } catch (error) {
            console.error("Error fetching wine data:", error);
        }
    };

    useEffect(() => {
        getWineData();
        getFilterOptions();
    }, [page, rowsPerPage]);

    const filteredNationArrays = filteredNationArray.filter((nation) =>
        nation.toLowerCase().includes(searchQuery.toLowerCase())
    );
    const filteredRegionArrays = filteredRegionArray.filter((nation) =>
        nation.toLowerCase().includes(searchQuery.toLowerCase())
    );
    const filteredWineArrays = filteredWineArray.filter((nation) =>
        nation.toLowerCase().includes(searchQuery.toLowerCase())
    );
    const filteredProductTypeArrays = filteredProductTypeArray.filter((nation) =>
        nation.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // const filteredCategoryTypeArrays = filteredCategoryTypeArary.filter((nation) =>
    //     nation.toLowerCase().includes(searchQuery.toLowerCase())
    // );


    const getRestProfileData = async () => {
        try {
            const responseProfileData = await axios.get(`${apiUrl}/api/v1/restaurants/${rest_slug2}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const AddAdressData = responseProfileData?.data?.addresses?.map((data) => ({
                id: data.id,
                label: data.address_title || "",
                address: data.address || "",
                city: data.city || "",
                postal_code: data.postal_code || "",
                province: data.province || "",
                telephone: data.telephone || "",
                mobile_no: data.mobile_no || "",
                email: data.email || ""
            })) || [];

            setAddresses(AddAdressData)
        } catch (error) {
            console.error('Error fetching Profile Settings data:', error);
        }
    };

    useEffect(() => {
        getRestProfileData();
    }, []);


    // Filter Toggle Functions
    // const handleNationFilter = (nation) => {
    //     if (!filteredNation.includes(nation)) {
    //         setFilteredNation((prevState) => [...prevState, nation]);
    //     } else {
    //         setFilteredNation((prevState) => prevState.filter((n) => n !== nation));
    //     }
    //     if (filteredNation.length === 0) {
    //         // setPage(1);
    //         getWineData("clear");
    //     }
    // };


    // const handleRegionFilter = (region) => {
    //     if (!filteredRegion.includes(region)) {
    //         setFilteredRegion((prevState) => [...prevState, region]);
    //     } else {
    //         setFilteredRegion((prevState) => prevState.filter((n) => n !== region));
    //     }
    // };

    // const handleWineFilter = (wine) => {
    //     if (!filteredWine.includes(wine)) {
    //         setFilteredWine((prevState) => [...prevState, wine]);
    //     } else {
    //         setFilteredWine((prevState) => prevState.filter((n) => n !== wine));
    //     }
    // };

    // const handleProductTypeFilter = (productType) => {
    //     if (!filteredProductType.includes(productType)) {
    //         setFilteredProductType((prevState) => [...prevState, productType]);
    //     } else {
    //         setFilteredProductType((prevState) =>
    //             prevState.filter((n) => n !== productType)
    //         );
    //     }
    // };


    const handleNationFilter = (nation) => {
        setFilteredNation((prevState) => {
            const updatedNation = prevState.includes(nation)
                ? prevState.filter((n) => n !== nation)
                : [...prevState, nation];

            if (updatedNation.length === 0) {
                getWineData("clear");
            }

            return updatedNation;
        });
    };

    const handleRegionFilter = (region) => {
        setFilteredRegion((prevState) => {
            const updatedRegion = prevState.includes(region)
                ? prevState.filter((n) => n !== region)
                : [...prevState, region];

            if (updatedRegion.length === 0) {
                getWineData("clear");
            }

            return updatedRegion;
        });
    };

    const handleWineFilter = (wine) => {
        setFilteredWine((prevState) => {
            const updatedWine = prevState.includes(wine)
                ? prevState.filter((n) => n !== wine)
                : [...prevState, wine];

            if (updatedWine.length === 0) {
                getWineData("clear");
            }

            return updatedWine;
        });
    };

    const handleProductTypeFilter = (productType) => {
        setFilteredProductType((prevState) => {
            const updatedProductType = prevState.includes(productType)
                ? prevState.filter((n) => n !== productType)
                : [...prevState, productType];

            if (updatedProductType.length === 0) {
                getWineData("clear");
            }

            return updatedProductType;
        });
    };

    // const handleCategoryTypeFilter = (categoryType) => {
    //     setFilteredCategoryType((prevState) => {
    //         const updatedCategoryType = prevState.includes(categoryType)
    //             ? prevState.filter((n) => n !== categoryType)
    //             : [...prevState, categoryType];

    //         if (updatedCategoryType.length === 0) {
    //             getWineData("clear");
    //         }

    //         return updatedCategoryType;
    //     });
    // };

    useEffect(() => {
        const fetchAllProvince = async () => {
            try {
                const response = await axios.get(`${apiUrl}/api/v1/provinces`, {
                    headers: { Authorization: `Bearer ${token}` },
                    // params: { search: searchQuery, pageNumber: page, size: rowsPerPage },
                });

                setAllProvinceData(response?.data || []);
            } catch (error) {
                console.error("Error fetching all wines", error);
            }
        };
        fetchAllProvince();
    }, [page, rowsPerPage]);

    useEffect(() => {
        setSearchQuery("");
    }, [showOptionProvince, showOption])

    //========================= all wines =========================

    const handleSave = async () => {

        setIsLoading({ ...isLoading, save: true });

        try {
            if (!token) {
                console.error('No token found in localStorage.');
                return;
            }

            const finalOrderData = {
                ...orderData,
                wines: selectedAllwines,
                destination_province: selectedProvince,
            };

            const response = await axios.post(
                `${apiUrl}/api/v1/restaurants/${rest_slug2}/orders`,
                finalOrderData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            getOrdersData();

            setIsAddOrder(false);

            toast.success(response?.data?.message, {
                theme: 'colored',
                autoClose: 1000,
            });
            navigate(`/restaurantPanel/incomingOrder/${localStorage.getItem("currentRestId") && localStorage.getItem("currentRestId")}`);

        } catch (error) {
            const errors = error?.response?.data?.errors;
            if (errors) {
                for (const key in errors) {
                    if (Array.isArray(errors[key])) {
                        errors[key].forEach((message) => {
                            toast.error(message, {
                                theme: 'colored',
                                autoClose: 3000,
                            });
                        });
                    }
                }
            } else {
                toast.error(error?.response?.data?.message, {
                    theme: "colored",
                    autoClose: 3000,
                });
            }
        } finally {
            setIsLoading({ ...isLoading, save: false });
        }
    };

    const handleCancel = () => {
        setIsAddOrder(false);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setOrderData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    // const handleChange = (e) => {
    //     const { name, value, type, checked } = e.target;
    //     const newValue = type === "checkbox" ? checked : value;

    //     setOrderData((prevData) => {
    //         let updatedData = {
    //             ...prevData,
    //             [name]: newValue,
    //         };

    //         if (name === "destination_name" && newValue.length === 0) {
    //             setSelectedAddressId(null);
    //             updatedData.destination_address = "";
    //         }

    //         return updatedData;
    //     });
    // };

    const toggleDropdownProvince = (key) => {
        setShowOptionProvince((prev) => ({
            destination_province: false,
            [key]: !prev[key],
        }));
        setSearchQueryProvince("");
    };

    const toggleDropdownAddress = (key) => {
        setShowOptionAddress((prev) => ({
            destination_address: false,
            [key]: !prev[key],
        }));
    };


    const filteredProvinceList = allProvinceData.filter((option) =>
        option?.name?.toLowerCase().includes(searchQueryProvince.toLowerCase())
    );

    const handleProvinceSelection = (provinceCode) => {
        setSelectedProvince((prevCode) => (prevCode === provinceCode ? null : provinceCode));
    };

    // const handleAddressSelection = (item) => {
    //     console.log(item, "item")
    //     setSelectedAddressId((prevId) => {
    //         const isSame = prevId === item.id;

    //         setOrderData((prev) => ({
    //             ...prev,
    //             destination_address: isSame ? null : item.address,
    //             destination_name: isSame ? null : item.label,
    //             destination_city: isSame ? null : item.city,
    //             destination_postal_code: isSame ? null : item.postal_code,
    //             destination_phone: isSame ? null : item.telephone,
    //             destination_mobile_phone: isSame ? null : item.mobile_no,
    //             destination_email: isSame ? null : item.email,
    //         }));

    //         setSelectedProvince((prevCode) => (prevCode === isSame ? null : item.province));

    //         return isSame ? null : item.id;
    //     });
    // };


    const handleAddressSelection = (item) => {

        setSelectedAddressId((prevId) => {
            const isSameSelection = prevId === item.id;
            const newId = isSameSelection ? null : item.id;

            setOrderData((prevOrderData) => ({
                ...prevOrderData,
                destination_name: isSameSelection ? null : item.label,
                destination_address: isSameSelection ? null : item.address,
                destination_city: isSameSelection ? null : item.city,
                destination_postal_code: isSameSelection ? null : item.postal_code,
                destination_phone: isSameSelection ? null : item.telephone,
                destination_mobile_phone: isSameSelection ? null : item.mobile_no,
                destination_email: isSameSelection ? null : item.email,
            }));

            setSelectedProvince(isSameSelection ? null : item.province);

            return newId;
        });
    };

    const handleCheckboxChange = (wine) => {
        if (!wine?.meta || wine?.meta?.length === 0) {
            toast.warning("Wine metadata is missing. Cannot select this item.", {
                theme: 'colored',
                autoClose: 1000,
            });
            return;
        }
        setSelectedAllwines((prevSelected) => {
            const isAlreadySelected = prevSelected.some((selectedWine) => selectedWine.id === wine.id);
            if (isAlreadySelected) {
                return prevSelected.filter((selectedWine) => selectedWine.id !== wine.id).map((wine, idx) => ({ ...wine, sr_no: idx + 1 }));
            } else {
                const initialQuantity = 0;

                const price = parseFloat(getB2bPriceForQuantity(wine.meta, initialQuantity)) || 0;
                const basePrice = price * initialQuantity;
                const taxAmount = basePrice * 0.22;
                const totalPrice = basePrice + taxAmount;

                return [
                    ...prevSelected,
                    {
                        id: wine.id,
                        sr_no: prevSelected.length + 1,
                        name: wine.name || "",
                        image: wine.image,
                        reference: wine.reference || "",
                        meta: wine?.meta,
                        quantity: initialQuantity,
                        price: price.toFixed(2),
                        total_price: totalPrice.toFixed(2),
                    },
                ].map((wine, idx) => ({ ...wine, sr_no: idx + 1 }));
            }
        });
    };

    const handleQuantityChange = (wineId, value) => {
        // let filteredValue = value.replace(/[^0-9]/g, '');
        let filteredValue = value.replace(/[^0-9]/g, '').slice(0, 3);

        if (filteredValue.length > 1 && filteredValue[0] === '0') {
            filteredValue = filteredValue.substring(1);
        }

        const updatedQuantity = filteredValue === '' ? 0 : Number(filteredValue);

        setAllwinesData(prevData =>
            prevData.map(wine => {
                if (wine.id === wineId) {
                    const price = parseFloat(getB2bPriceForQuantity(wine.meta, updatedQuantity)) || 0;
                    const basePrice = price * updatedQuantity;
                    const taxAmount = basePrice * 0.22;
                    const finalPrice = basePrice + taxAmount;

                    return {
                        ...wine,
                        currentQuantity: updatedQuantity,
                        currentPrice: price,
                        total_price: finalPrice.toFixed(2)
                    };
                }
                return wine;
            })
        );

        setSelectedAllwines(prevSelected => {
            return prevSelected.map((wine, idx) =>
                wine.id === wineId
                    ? {
                        ...wine,
                        sr_no: idx + 1,
                        name: wine.name || "",
                        image: wine.image,
                        reference: wine.reference || "",
                        quantity: updatedQuantity,
                        price: parseFloat(getB2bPriceForQuantity(wine.meta, updatedQuantity)).toFixed(2) || "0.00",
                        total_price: ((parseFloat(getB2bPriceForQuantity(wine.meta, updatedQuantity)) || 0) * updatedQuantity * 1.22).toFixed(2)
                    }
                    : { ...wine, sr_no: idx + 1 }
            );
        });
    };

    // console.log(selectedAllwines, "select all wins")

    // const getB2bPriceForQuantity = (meta, quantity) => {

    //     if (!meta || meta.length === 0) return "0.00";

    //     const qty = parseInt(quantity) || 0;

    //     const sortedMeta = [...meta].sort((a, b) => a.quantity - b.quantity);

    //     let selectedTier = sortedMeta.find(tier => qty <= tier.quantity);

    //     if (!selectedTier) {
    //         selectedTier = sortedMeta[sortedMeta.length - 1];
    //     }

    //     return selectedTier?.b2b_price || "0.00";
    // };

    const getB2bPriceForQuantity = (meta, quantity) => {
        if (!meta || meta.length === 0) return "0.00";

        const qty = parseInt(quantity) || 0;

        // Sort tiers in descending order of quantity
        const sortedMeta = [...meta].sort((a, b) => b.quantity - a.quantity);

        // Find the first tier where the ordered quantity is >= tier's minimum quantity
        const selectedTier = sortedMeta.find(tier => qty >= tier.quantity);

        // If no tier found (quantity is below all tiers), use the first tier (highest price)
        if (!selectedTier) {
            return sortedMeta[sortedMeta.length - 1]?.b2b_price || "0.00";
        }

        return selectedTier.b2b_price || "0.00";
    };

    // const handleAddressSelectOld = (item) => {
    //     setSelectedAddressId(item.id);
    //     setOrderData(prev => ({
    //         ...prev,
    //         destination_address: item.address
    //     }));
    // };

    // const handleAddressSelect = (item) => {
    //     setSelectedAddressId((prevId) => {
    //         const isSame = prevId === item.id;

    //         setOrderData((prev) => ({
    //             ...prev,
    //             destination_address: isSame ? null : item.address,
    //         }));

    //         return isSame ? null : item.id;
    //     });
    // };

    return (
        <section className="sm:mt-3 mt-0 pt-2">
            <h3 className="text-2xl font-bold mb-4 poppins-medium">Aggiungi Ordine</h3>
            {/* <div className="flex flex-wrap gap-1 mt-2 p-2">
                {addresses?.length > 0 && addresses.map((item) => (
                    <div
                        key={item.id}
                        className="flex items-center min-w-[120px] max-w-full"
                    >
                        <input
                            type="radio"
                            id={`address-${item.id}`}
                            name="delivery-address"
                            checked={selectedAddressId === item.id}
                            onChange={() => handleAddressSelect(item)}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 mr-3 filter_list_btn cursor-pointer"
                        />
                        <label
                            htmlFor={`address-${item.id}`}
                            className="text-sm font-medium text-gray-800  truncate"
                        >
                            {item.label}
                        </label>
                    </div>
                ))}
            </div> */}


            {/* <div className="flex flex-wrap gap-1 mt-2 p-2">
                {addresses?.length > 0 &&
                    addresses.map((item) => {
                        const isSelected = selectedAddressId === item.id;

                        return (
                            <div
                                key={item.id}
                                className="flex items-center min-w-[120px] max-w-full"
                                onClick={() => handleAddressSelect(item)}
                            >
                                <input
                                    type="radio"
                                    id={`address-${item.id}`}
                                    name="delivery-address"
                                    checked={isSelected}
                                    // onChange={() => handleAddressSelect(item)}
                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 mr-3 filter_list_btn cursor-pointer"
                                />
                                <label
                                    htmlFor={`address-${item.id}`}
                                    className="text-sm font-medium text-gray-800 truncate cursor-pointer"
                                >
                                    {item.label}
                                </label>
                            </div>
                        );
                    })}
            </div> */}

            <div className="w-full h-auto bg-[#FCFCFC] md:p-10 p-4 rounded-xl shadow-lg space-y-6">

                <OrderFormFields
                    orderData={orderData}
                    setOrderData={setOrderData}
                    handleChange={handleChange}
                    showOptionProvince={showOptionProvince}
                    setShowOptionProvince={setShowOptionProvince}
                    allwinesData={allwinesData}
                    selectedAllwines={selectedAllwines}
                    searchQueryProvince={searchQueryProvince}

                    setSearchQueryProvince={setSearchQueryProvince}


                    allProvinceData={allProvinceData}
                    setSelectedProvince={setSelectedProvince}
                    selectedProvince={selectedProvince}
                    filteredProvinceList={filteredProvinceList}
                    toggleDropdownProvince={toggleDropdownProvince}
                    handleProvinceSelection={handleProvinceSelection}




                    showOptionAddress={showOptionAddress}
                    setShowOptionAddress={setShowOptionAddress}
                    toggleDropdownAddress={toggleDropdownAddress}
                    addresses={addresses}
                    handleAddressSelection={handleAddressSelection}
                    selectedAddressId={selectedAddressId}
                />


                <OrderWineFilter
                    showOption={showOption}
                    setShowOption={setShowOption}

                    filteredNation={filteredNation}
                    filteredRegion={filteredRegion}
                    filteredWine={filteredWine}
                    filteredProductType={filteredProductType}
                    // filteredCategoryType={filteredCategoryType}

                    handleNationFilter={handleNationFilter}
                    handleRegionFilter={handleRegionFilter}
                    handleWineFilter={handleWineFilter}
                    handleProductTypeFilter={handleProductTypeFilter}
                    // handleCategoryTypeFilter={handleCategoryTypeFilter}

                    filteredNationArrays={filteredNationArrays}
                    filteredRegionArrays={filteredRegionArrays}
                    filteredWineArrays={filteredWineArrays}
                    filteredProductTypeArrays={filteredProductTypeArrays}
                    // filteredCategoryTypeArrays={filteredCategoryTypeArrays}

                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}

                    getWineData={getWineData}
                    setPage={setPage}
                />


                <OrderSearchBar
                    getWineData={getWineData}
                    searchCodice={searchCodice}
                    setSearchCodice={setSearchCodice}
                    searchNome={searchNome}
                    setSearchNome={setSearchNome}
                    setAllwinesData={setAllwinesData}
                    setPage={setPage}
                />

                <div className=" wine-main-table w-auto h-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow">

                    <table className="w-full text-left wine_table">
                        <thead>
                            <tr className="border-b border-[#8B2433]">
                                <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">
                                </th>
                                <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">
                                    Immagine
                                </th>
                                <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                                    Nome
                                </th>
                                <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                                    Tipologia
                                </th>
                                <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                                    Nazione
                                </th>
                            </tr>
                        </thead>
                        {isLoading?.main ? (
                            <TableLoader />
                        ) : (
                            <tbody>
                                {allwinesData?.length > 0 ? (
                                    allwinesData.map((wine, index) => {
                                        // const serialNumber = (page - 1) * rowsPerPage + index + 1;
                                        return (
                                            <tr key={index} className="border-b border-[#8B2433]/12 text-sm">
                                                <td className="py-4 text-left poppins-regular">
                                                    <input
                                                        type="checkbox"
                                                        className="h-4 w-4 border rounded-md accent-[#8B2433] mr-2 poppins-regular"
                                                        checked={selectedAllwines.some((selectedWine) => selectedWine.id === wine.id)}
                                                        onChange={() => handleCheckboxChange(wine, index)}
                                                    />

                                                </td>

                                                <td className="pr-2 py-4">
                                                    <div className="relative thumbnail_image rounded-lg w-[50px] h-[60px] bg-white p-1 flex align-center justify-center">
                                                        <img
                                                            className="w-[100px] h-100 object-contain border border-[#68172394] rounded-lg p-1"
                                                            src={wine?.image && wine?.image !== "" ? wine?.image : defaultImage}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                    {wine?.name || "N/A"}
                                                </td>
                                                <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                    {wine?.product_type || "N/A"}
                                                </td>
                                                <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                    {wine?.nation || "N/A"}
                                                </td>
                                                {/* <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                    {getB2bPriceForQuantity(
                                                        wine?.meta,
                                                        allwinesData.find(item => item.id === wine.id)?.currentQuantity ??
                                                        selectedAllwines?.find(item => item.id === wine.id)?.quantity ??
                                                        0
                                                    )}
                                                </td> */}
                                                {/* <td className="py-4 px-2 text-left poppins-medium text-[#303030]">22%</td> */}
                                                {/* <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                    <input
                                                        type="text"
                                                        name="quantity"
                                                        value={
                                                            selectedAllwines?.find(item => item.id === wine.id)?.quantity === 0
                                                                ? ""
                                                                : selectedAllwines?.find(item => item.id === wine.id)?.quantity ??
                                                                (allwinesData.find(item => item.id === wine.id)?.currentQuantity === 0
                                                                    ? ""
                                                                    : allwinesData.find(item => item.id === wine.id)?.currentQuantity) ??
                                                                ""
                                                        }
                                                        onChange={(e) => handleQuantityChange(wine.id, e.target.value)}
                                                        disabled={!wine?.meta || wine?.meta?.length === 0}
                                                        className={`border-[3px] px-2 py-1 w-[40%] rounded-xl w-[60%]
                            ${!wine?.meta || wine?.meta?.length === 0 ? "cursor-not-allowed bg-gray" : "border-[#303030]"}`}
                                                    />
                                                </td> */}

                                                {/* <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                    {(() => {
                                                        const selectedWine = selectedAllwines?.find((item) => item.id === wine.id);

                                                        if (!selectedWine) {
                                                            return "0.00 €";
                                                        }

                                                        const quantity = parseInt(selectedWine.quantity) || 0;
                                                        const servedPrice = parseFloat(getB2bPriceForQuantity(wine.meta, quantity)) || 0;
                                                        const basePrice = servedPrice * quantity;
                                                        const taxAmount = basePrice * 0.22;
                                                        const finalPrice = basePrice + taxAmount;

                                                        return `${finalPrice.toFixed(2)} €`;
                                                    })()}
                                                </td> */}
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={9} className="text-center py-4">
                                            No wines found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        )}
                    </table>
                </div>

                {allwinesData && allwinesData?.length > 0 && (
                    <PaginationComponent
                        page={page}
                        totalPages={totalPages}
                        rowsPerPage={rowsPerPage}
                        setPage={setPage}
                        setRowsPerPage={setRowsPerPage}
                    />
                )}

                <OrderCart
                    selectedAllwines={selectedAllwines}
                    allwinesData={allwinesData}
                    handleCheckboxChange={handleCheckboxChange}
                    getB2bPriceForQuantity={getB2bPriceForQuantity}
                    handleQuantityChange={handleQuantityChange}
                    setSelectedAllwines={setSelectedAllwines}
                />

                {/* <div className="font-bold text-[#303030] py-2 bg-[#8A2533] text-white border-2 border-[#953543] transition-colors rounded-3xl flex justify-between items-center px-4">

                    <span className="w-1/3 text-left poppins-medium">
                        Pezzi:{" "}
                        {selectedAllwines.length > 0
                            ? selectedAllwines.reduce((sum, wine) => sum + (parseInt(wine.quantity) || 0), 0)
                            : 0}
                    </span>

                    <span className="w-1/3 text-center poppins-medium">
                        Totale ordine:{" "}
                        {selectedAllwines.length > 0
                            ? `${selectedAllwines.reduce((sum, wine) => sum + parseFloat(wine.total_price || 0), 0).toFixed(2)} €`
                            : "0.00 €"}
                    </span>

                    <span className="w-1/3"></span>
                </div> */}

                <div className="font-bold text-[#303030] py-2 bg-[#8A2533] text-white border-2 border-[#953543] transition-colors rounded-3xl flex justify-end items-center px-4 gap-x-6">
                    <span className="w-auto text-left poppins-medium">
                        Pezzi:{" "}
                        {selectedAllwines.length > 0
                            ? selectedAllwines.reduce((sum, wine) => sum + (parseInt(wine.quantity) || 0), 0)
                            : 0}
                    </span>

                    <span className="w-auto text-center poppins-medium">
                        Totale ordine:{" "}
                        {selectedAllwines.length > 0
                            ? `${selectedAllwines.reduce((sum, wine) => sum + parseFloat(wine.total_price || 0), 0).toFixed(2)} €`
                            : "0.00 €"}
                    </span>

                    <span className="w-auto"></span>
                </div>

                <div className="flex sm:flex-row flex-col text-sm justify-start gap-4 mt-4">
                    {isLoading.save ? (
                        <button disabled type="button"
                            className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group">
                            <svg
                                aria-hidden="true"
                                className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor"
                                />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill"
                                />
                            </svg>
                            Loading...
                        </button>
                    ) : (
                        <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                            onClick={handleSave}
                            disabled={isLoading.save}
                        >
                            <TiTick size={"25px"} color="green" />
                            <span className="poppins-regular">Salva</span>
                        </button>
                    )}
                    <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                        onClick={handleCancel}
                    >
                        <IoClose size={"25px"} color="red" className="group-hover:invert" />
                        <span className="poppins-regular">Annulla</span>
                    </button>
                </div>
            </div>
        </section>
    );
};


export default OrderAdd;
